import type { CatalogRole } from '../types.js';

/**
 * The predefined role keys every tenant gets.
 */
export const ROLE_KEYS = {
  COMPANY_ADMIN: 'company-admin',
  COMPANY_CREATOR: 'company-creator',
  COMPANY_READER: 'company-reader',
} as const;

export const RETRACED_ROLE_KEYS = {
  RETRACED_ADMIN: 'retraced-admin',
  RETRACED_SALES: 'retraced-sales',
  RETRACED_PRODUCT_DEVELOPMENT: 'retraced-product-development',
  RETRACED_CUSTOMER_SUCCESS: 'retraced-customer-success',
  RETRACED_MARKETING: 'retraced-marketing',
} as const;

/** The predefined (system) roles every tenant gets. Identity only — the actual
 *  grants live on each resource (see `resources/`). None of these can be
 *  deleted, and none can have its grants changed — see `IMMUTABLE_ROLE_KEYS`. */
export const PREDEFINED_ROLES: readonly CatalogRole[] = [
  // Note: Initially we named as creator and reader now we change to editor and read-only.
  // We do not want to change keys (they are embedded in the IAM enforcement path).
  // `name` is the label users read; the key is the contract
  // Creator shows as "Editor" and
  // Reader as "Read-Only"
  { key: ROLE_KEYS.COMPANY_ADMIN, name: 'Admin' },
  { key: ROLE_KEYS.COMPANY_CREATOR, name: 'Editor' },
  { key: ROLE_KEYS.COMPANY_READER, name: 'Read-Only' },
];

export const IMMUTABLE_ROLE_KEYS: readonly string[] = PREDEFINED_ROLES.map(
  r => r.key,
);

/** Whether `key` names a role whose grants are fixed by the catalog. */
export const isImmutableRoleKey = (key: string): boolean =>
  IMMUTABLE_ROLE_KEYS.includes(key);
